var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4039 7.06031L11.9998 11.8583L21.5959 7.06025C21.5235 5.79983 20.4785 4.80005 19.1999 4.80005H4.7999C3.52132 4.80005 2.47626 5.79986 2.4039 7.06031Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 9.74153L11.9998 14.5416L2.3999 9.7416V16.8C2.3999 18.1255 3.47442 19.2 4.7999 19.2H19.1999C20.5254 19.2 21.5999 18.1255 21.5999 16.8V9.74153Z",
    fill: "#4FC0CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSolid);
export default __webpack_public_path__ + "static/media/mail-solid.fd5c6ff347a1ce4b953ad4e02046e43d.svg";
export { ForwardRef as ReactComponent };